'use client';

import React, { createContext, useContext, useState, useEffect } from 'react';
import { usePathname } from 'next/navigation';

interface NavigationContextType {
    navigatingPath: string | null;
    setNavigatingPath: (path: string | null) => void;
    isViewingOwnJob: boolean;
    setIsViewingOwnJob: (val: boolean) => void;
    highlightJobsMenu: boolean;
    setHighlightJobsMenu: (val: boolean) => void;
}

const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

export function NavigationProvider({ children }: { children: React.ReactNode }) {
    const [navigatingPath, setNavigatingPath] = useState<string | null>(null);
    const [isViewingOwnJob, setIsViewingOwnJob] = useState<boolean>(false);
    const [highlightJobsMenu, setHighlightJobsMenu] = useState<boolean>(false);
    const pathname = usePathname();

    // Reset navigating status when pathname changes
    useEffect(() => {
        setNavigatingPath(null);
        setIsViewingOwnJob(false);
        setHighlightJobsMenu(false);
    }, [pathname]);

    return (
        <NavigationContext.Provider value={{ 
            navigatingPath, 
            setNavigatingPath,
            isViewingOwnJob,
            setIsViewingOwnJob,
            highlightJobsMenu,
            setHighlightJobsMenu
        }}>
            {children}
        </NavigationContext.Provider>
    );
}

export function useNavigation() {
    const context = useContext(NavigationContext);
    if (context === undefined) {
        throw new Error('useNavigation must be used within a NavigationProvider');
    }
    return context;
}
